import { render, staticRenderFns } from "./HubLeaderBoardTable.vue?vue&type=template&id=3203eae1"
import script from "./HubLeaderBoardTable.vue?vue&type=script&lang=js"
export * from "./HubLeaderBoardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports